<div class="modal__header">
	<h2 class="title" id="modal__title">Pending Extras</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>
<div class="modal__body sl--scrollable">
	You currently have added extras to your flight. These changes will be discarded if you proceed without completing the purchase.
</div>
<div class="modal__footer">
	<div class="modal__footer-action negative-action"><button class="button button--small" (click)="discardExtras()">Discard Extras</button></div>
	<div class="modal__footer-action positive-action"><button (click)="goToPayment()" class="button button--small button-accent button--icon-right">Complete Purchase <app-svg svg="icons.svg#general--arrow--right" aria-hidden="true" [alt]="'Arrow right icon'"></app-svg></button></div>
</div>
